export interface TabItem {
  name: string;
  disabled?: boolean;
  url?: string;
  termKey?: string;
}
